import httpClient from "@/services/http/mainServerClient";
import { get } from "@/services/http/platformServer";

export interface CaptchaResult {
    key: string;

    value: string;
}

/** main获取 */
export function getCaptcha(): Promise<CaptchaResult> {
    return httpClient.get("/captcha");
}

/** node获取 */
export function getCaptchaByNode(shopId: number): Promise<CaptchaResult> {
    return get(shopId, "/captcha");
}
